/* PK: hide the Google My Maps header bar on embedded maps.
   Cross-origin iframe cannot be styled, so each iframe[src*="google.com/maps/d/"] is wrapped
   in .pk-mymap-crop (overflow:hidden) and shifted up by CROP px while made CROP px taller,
   so the visible block keeps its original size and shows only the map.
   Opt-out: add data-pk-mymap-keep-header to the iframe. */
(function () {
  'use strict';
  var CROP = 68; /* measured header height: 67px bar + 1px border, same on desktop and mobile */
  var SEL = 'iframe[src*="google.com/maps/d/"]:not([data-pk-mymap-keep-header])';
  var items = [];
  var io = null;

  function layout(item) {
    var w = item.wrap, f = item.frame;
    /* measure the iframe as the theme lays it out, with the wrapper out of the box tree */
    f.style.removeProperty('height');
    f.style.removeProperty('margin-top');
    w.style.cssText = 'display:contents';
    w.classList.remove('pk-mymap-crop');
    var r = f.getBoundingClientRect();
    var cs = window.getComputedStyle(f); /* live object: copy values before touching classes */
    var W = r.width, H = r.height;
    var bt = parseFloat(cs.borderTopWidth) || 0;
    var display = cs.display, va = cs.verticalAlign;
    var margin = cs.marginTop + ' ' + cs.marginRight + ' ' + cs.marginBottom + ' ' + cs.marginLeft;
    var radius = cs.borderTopLeftRadius + ' ' + cs.borderTopRightRadius + ' ' + cs.borderBottomRightRadius + ' ' + cs.borderBottomLeftRadius;
    if (!W || !H) {
      /* hidden right now (tab, accordion, display:none): retry when it becomes visible */
      w.classList.add('pk-mymap-crop'); w.style.cssText = '';
      if (io && !item.observed) { item.observed = true; io.observe(w.parentNode); }
      return;
    }
    var disp = display === 'inline' || display === 'inline-block' ? 'inline-block' : 'block';
    w.classList.add('pk-mymap-crop');
    w.style.cssText =
      'display:' + disp + ';position:relative;overflow:hidden;max-width:100%;' +
      'width:' + W + 'px;height:' + H + 'px;' +
      'margin:' + margin + ';' +
      'border-radius:' + radius + ';' +
      'vertical-align:' + va + ';' +
      '--pk-mymap-crop:' + (CROP + bt) + 'px;';
    /* iframe top border + header bar sit above the wrapper; bottom edge stays aligned */
    f.style.setProperty('height', (H + CROP + bt) + 'px', 'important');
    f.style.setProperty('margin-top', -(CROP + bt) + 'px', 'important');
  }

  function relayout() {
    for (var i = 0; i < items.length; i++) layout(items[i]);
  }

  function wrap(f) {
    if (f.getAttribute('data-pk-mymap-crop') === '1' || !f.parentNode) return;
    f.setAttribute('data-pk-mymap-crop', '1');
    var w = document.createElement('div');
    w.className = 'pk-mymap-crop';
    f.parentNode.insertBefore(w, f);
    w.appendChild(f);
    var item = { frame: f, wrap: w, observed: false };
    items.push(item);
    layout(item);
  }

  function scan(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) wrap(list[i]);
  }

  var t;
  function schedule() {
    if (t) cancelAnimationFrame(t);
    t = requestAnimationFrame(function () { t = null; relayout(); });
  }

  function init() {
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) { schedule(); break; }
      });
    }
    scan(document);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('load', schedule);
    /* maps injected later (sections re-rendered, theme editor, lazy content) */
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'attributes') { if (m.target.matches && m.target.matches(SEL)) wrap(m.target); continue; }
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches(SEL)) wrap(n); else if (n.querySelector && n.querySelector(SEL)) scan(n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); schedule(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
